/* unplugin-vue-components disabled */import { render } from "./menu-item.vue?vue&type=template&id=c6d2ae20"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/menu-side/menu-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6d2ae20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6d2ae20', __exports__)) {
    console.log('reload')
    api.reload('c6d2ae20', __exports__)
  }
  
  module.hot.accept("./menu-item.vue?vue&type=template&id=c6d2ae20", () => {
    console.log('re-render')
    api.rerender('c6d2ae20', render)
  })

}


export default __exports__